import { render, staticRenderFns } from "./ComponentDoc.vue?vue&type=template&id=43b4fce2&"
import script from "./ComponentDoc.vue?vue&type=script&lang=js&"
export * from "./ComponentDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports